import type { SVGProps } from 'react'
import type { IconName } from '../lib/permissions'

export type AnyIcon =
  | IconName | 'search' | 'calendar' | 'chevron-down' | 'chevron-right' | 'chevron-left' | 'check' | 'x' | 'plus' | 'upload'
  | 'download' | 'printer' | 'qr' | 'wifi-off' | 'camera' | 'trash' | 'filter' | 'arrow-up-right' | 'info' | 'triangle-alert'
  | 'menu' | 'logout' | 'refresh' | 'lock' | 'droplet' | 'gauge' | 'nfc' | 'power' | 'map' | 'flag' | 'history' | 'wrench' | 'save'

const P: Record<AnyIcon, string> = {
  dashboard: 'M3 13h8V3H3v10Zm0 8h8v-6H3v6Zm10 0h8V11h-8v10Zm0-18v6h8V3h-8Z',
  assets: 'M12 2 3 7v10l9 5 9-5V7l-9-5Zm0 2.3 6.5 3.6L12 11.5 5.5 7.9 12 4.3ZM5 9.6l6 3.3v6.5l-6-3.3V9.6Zm8 9.8v-6.5l6-3.3v6.5l-6 3.3Z',
  inspections: 'M9 2h6l1 2h3a1 1 0 0 1 1 1v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a1 1 0 0 1 1-1h3l1-2Zm.6 2-.5 1H7v1h10V5h-2.1l-.5-1H9.6ZM8 11l2.2 2.2L15 8.5l1.4 1.4-6.2 6.3L6.6 12.6 8 11Z',
  workorders: 'M14.7 6.3a4 4 0 0 0-5.2 5.1L3 18l3 3 6.6-6.5a4 4 0 0 0 5.1-5.2l-2.6 2.6-2.3-.6-.6-2.3 2.5-2.7Z',
  findings: 'M12 2 1 21h22L12 2Zm-1 7h2v6h-2V9Zm0 8h2v2h-2v-2Z',
  lubrication: 'M12 2s6 6.3 6 11a6 6 0 0 1-12 0c0-4.7 6-11 6-11Zm-2.5 11.5a2.5 2.5 0 0 0 2.5 2.5v1.5a4 4 0 0 1-4-4h1.5Z',
  measurements: 'M13 2 4 14h6l-1 8 9-12h-6l1-8Z',
  alerts: 'M12 22a2.5 2.5 0 0 0 2.4-2h-4.8A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5-6.7V3a2 2 0 0 0-4 0v1.3A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Z',
  quality: 'M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3Zm-1 14-4-4 1.4-1.4L11 13.2l4.6-4.6L17 10l-6 6Z',
  imports: 'M12 3v12m0 0-4-4m4 4 4-4M4 17v3h16v-3',
  exports: 'M12 15V3m0 0L8 7m4-4 4 4M4 17v3h16v-3',
  templates: 'M5 3h10l4 4v14H5V3Zm9 1.5V8h3.5L14 4.5ZM8 12h8v1.5H8V12Zm0 3.5h8V17H8v-1.5Z',
  users: 'M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm-8 0a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm0 2c-2.3 0-7 1.2-7 3.5V19h8v-2.5c0-1 .4-1.9 1-2.6-.9-.6-1.9-.9-2-.9Zm8 0c-.3 0-.6 0-1 .1 1.2.8 2 1.8 2 3.4V19h6v-2.5c0-2.3-4.7-3.5-7-3.5Z',
  clients: 'M3 21V7l9-5 9 5v14h-7v-6h-4v6H3Zm3-11h2V8H6v2Zm5 0h2V8h-2v2Zm5 0h2V8h-2v2Zm-10 4h2v-2H6v2Zm10 0h2v-2h-2v2Z',
  more: 'M5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z',
  bell: 'M12 22a2.5 2.5 0 0 0 2.4-2h-4.8A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5-6.7V3a2 2 0 0 0-4 0v1.3A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Z',
  scan: 'M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4M4 12h16',
  search: 'M10.5 3a7.5 7.5 0 0 1 5.9 12.1l4.3 4.3-1.4 1.4-4.3-4.3A7.5 7.5 0 1 1 10.5 3Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z',
  calendar: 'M7 2v2H4a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3V2h-2v2H9V2H7ZM5 9h14v10H5V9Z',
  'chevron-down': 'm6 9 6 6 6-6',
  'chevron-right': 'm9 6 6 6-6 6',
  'chevron-left': 'm15 6-6 6 6 6',
  check: 'm5 12 5 5 9-10',
  x: 'M6 6l12 12M18 6 6 18',
  plus: 'M12 5v14M5 12h14',
  upload: 'M12 15V3m0 0L8 7m4-4 4 4M4 17v3h16v-3',
  download: 'M12 3v12m0 0-4-4m4 4 4-4M4 17v3h16v-3',
  printer: 'M7 3h10v5H7V3Zm-3 6h16a1 1 0 0 1 1 1v7h-4v4H7v-4H3v-7a1 1 0 0 1 1-1Zm5 6v4h6v-4H9Z',
  qr: 'M3 3h7v7H3V3Zm2 2v3h3V5H5Zm9-2h7v7h-7V3Zm2 2v3h3V5h-3ZM3 14h7v7H3v-7Zm2 2v3h3v-3H5Zm9-2h3v3h-3v-3Zm4 0h3v3h-3v-3Zm-4 4h3v3h-3v-3Zm4 0h3v3h-3v-3Z',
  'wifi-off': 'M2 2l20 20M8.5 16.4a5 5 0 0 1 7 0M5 12.6a10 10 0 0 1 3-2M2 8.8a15 15 0 0 1 4.5-2.7M12 20h.01',
  camera: 'M9 3 7.2 5H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3.2L15 3H9Zm3 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
  trash: 'M9 3h6l1 2h4v2H4V5h4l1-2ZM6 9h12l-1 12H7L6 9Z',
  filter: 'M3 5h18l-7 8v6l-4 2v-8L3 5Z',
  'arrow-up-right': 'M7 17 17 7M8 7h9v9',
  info: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 8h2v7h-2v-7Zm0-3h2v2h-2V7Z',
  'triangle-alert': 'M12 2 1 21h22L12 2Zm-1 7h2v6h-2V9Zm0 8h2v2h-2v-2Z',
  menu: 'M4 6h16M4 12h16M4 18h16',
  logout: 'M10 3H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h5M15 7l5 5-5 5M20 12H9',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5',
  lock: 'M7 10V7a5 5 0 0 1 10 0v3h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1Zm2 0h6V7a3 3 0 0 0-6 0v3Z',
  droplet: 'M12 2s6 6.3 6 11a6 6 0 0 1-12 0c0-4.7 6-11 6-11Z',
  gauge: 'M12 4a9 9 0 0 0-9 9c0 2 .7 3.9 1.8 5.3h14.4A9 9 0 0 0 12 4Zm0 2a7 7 0 0 1 6.6 4.7L13.4 13a2 2 0 1 0-1.2 1.6l5.9-2.3A7 7 0 0 1 18 16H6a7 7 0 0 1 6-10Z',
  nfc: 'M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm4 4c2.5 2.3 2.5 5.7 0 8m3-10c3.5 3.2 3.5 8.8 0 12',
  power: 'M12 2v10M6.3 6.3a8 8 0 1 0 11.4 0',
  map: 'M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Zm0 2v12m6-10v12',
  flag: 'M5 21V4h11l-1.5 4L16 12H7v9H5Z',
  history: 'M3 12a9 9 0 1 0 3-6.7L3 8m0-5v5h5m4-1v5l3 2',
  wrench: 'M14.7 6.3a4 4 0 0 0-5.2 5.1L3 18l3 3 6.6-6.5a4 4 0 0 0 5.1-5.2l-2.6 2.6-2.3-.6-.6-2.3 2.5-2.7Z',
  save: 'M5 3h12l4 4v14H3V3h2Zm2 2v5h8V5H7Zm5 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
}

const STROKE = new Set<AnyIcon>([
  'imports', 'exports', 'scan', 'chevron-down', 'chevron-right', 'chevron-left', 'check', 'x', 'plus', 'upload', 'download',
  'wifi-off', 'arrow-up-right', 'menu', 'logout', 'refresh', 'history', 'power', 'map', 'nfc',
])

export function Icon({ name, size = 20, title, ...rest }: { name: AnyIcon; size?: number; title?: string } & Omit<SVGProps<SVGSVGElement>, 'name'>) {
  const stroke = STROKE.has(name)
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
      fill={stroke ? 'none' : 'currentColor'}
      stroke={stroke ? 'currentColor' : 'none'}
      strokeWidth={stroke ? 2 : undefined}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path d={P[name]} />
    </svg>
  )
}
